import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class ScrollFunc {
    constructor() {
        this.init();
    }

    init() {
        this.smoothScroll();
        window.addEventListener("load", this.onScroll);
    }

    onScroll() {
        const revealElm = [...document.querySelectorAll(".js-scrollreveal")];

        revealElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 80%",
                //markers: true,
                onEnter: () => {
                    el.classList.add("-reveal");
                },
            });
        });

        ScrollTrigger.create({
            trigger: ".kv__scroll",
            start: "top 100%",
            //markers: true,
            onEnter: () => {
                document.body.setAttribute("data-scrolled", "1");
            },
            onLeaveBack: () => {
                document.body.setAttribute("data-scrolled", "0");
            },
        });



        // スクロール中にバナーを変化させる
        let timeout = null
        window.addEventListener('scroll', () => {
            clearTimeout(timeout)

            document.body.classList.add('-onscroll')

            timeout = setTimeout(() => {
                document.body.classList.remove('-onscroll')
            }, 500)
        })

    }

    smoothScroll() {
        const triggers = [...document.querySelectorAll(".js-smoothscroll")];
        const pagetop = [...document.querySelectorAll(".js-pagetop")];

        triggers.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                const hash = el.getAttribute("href");
                const offset = window.innerWidth <= 834 ? window.innerWidth * 0.3 : 100 * (window.innerWidth / 1920);
                gsap.to(window, { duration: 1, scrollTo: { y: hash, offsetY: offset }, ease: "circ.inOut" });
            });
        });

        pagetop.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                gsap.to(window, { duration: 1, scrollTo: { y: 0 }, ease: "circ.inOut" });
            });
        });
    }
}
